module.exports = __webpack_public_path__ + "img/white-w-disc-w-case-closed.610433c2.svg";